import React, { useEffect } from 'react';
import { InputTextArea } from '@bb/elements-web';
import { AccessOptionProps } from '../../types';

const SentrilockApp: React.FC<AccessOptionProps> = ({
  showingsConfig,
  setShowingsConfig,
  setIsValid,
}) => {
  useEffect(() => {
    setIsValid(Boolean(showingsConfig.instructions.sentrilockapp?.details));
  }, [setIsValid, showingsConfig]);

  return (
    <div>
      <InputTextArea
        label="Instructions"
        labelExtra="(optional)"
        dataCy="showing-notification-sentrilock-v1-instructions"
        value={showingsConfig.instructions.sentrilockapp?.details || ''}
        minHeight={100}
        onChange={value =>
          setShowingsConfig(prev => ({
            ...prev,
            instructions: {
              ...prev.instructions,
              sentrilockapp: {
                ...(prev.instructions.sentrilockapp || {}),
                details: value,
              },
            },
          }))
        }
      />
    </div>
  );
};

export default SentrilockApp;
